export const environment = {
  production: false,
  apiUrl: 'https://apitest.jaca.com.py/api/v3/doctores/', //testing
};
